document.addEventListener('DOMContentLoaded', () => {
  var progressPath = document.querySelector('.button__back-to-top .progress-circle path');
  if (!progressPath) return;
  var pathLength = progressPath.getTotalLength();

  progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
  progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
  progressPath.style.strokeDashoffset = pathLength;
  progressPath.style.transition = progressPath.style.WebkitTransition = 'none';

  var lastProgress = null;
  var maxScroll = 1;
  var ticking = false;

  function getScrollY() {
    return window.scrollY || window.pageYOffset;
  }

  function measureHeight() {
    maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    if (maxScroll <= 0) maxScroll = 1;
  }

  function updateProgress() {
    var scroll = getScrollY();
    var progress = pathLength - (scroll * pathLength) / maxScroll;
    if (lastProgress !== progress) {
      progressPath.style.strokeDashoffset = progress;
      lastProgress = progress;
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      measureHeight();
      updateProgress();
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener(
    'resize',
    theme.utils.rafThrottle(function () {
      measureHeight();
      updateProgress();
    })
  );

  measureHeight();
  updateProgress();
});